import { LayoutContext } from "../contexts/layout.js";
import { useContext } from "react";
import { isNullish } from "remeda";
//#region src/hooks/layout-context.ts
const useLayoutContext = () => {
	const value = useContext(LayoutContext);
	if (isNullish(value)) throw new Error("`useLayoutContext` must be used within a `LayoutContextProvider`");
	else return value;
};
//#endregion
export { useLayoutContext };

//# sourceMappingURL=layout-context.js.map